//# sourceMappingURL=unsafe.mjs.map
/// <reference types="./unsafe.d.mts" />
import * as $document from "../../../magellan/magellan/document.mjs";

export function listen_dom_click(dispatch) {
  let _pipe = $document.options();
  let _pipe$1 = $document.once(_pipe, true);
  ((_capture) => {
    return $document.add_event_listener("click", dispatch, _capture);
  })(_pipe$1);
  return () => {
    return $document.remove_event_listener("click", dispatch, false);
  };
}
